/**
 * Utilitaire de wording dynamique selon le vendorType de la societe
 *
 * Garant (1) -> "Garantie", "Garanties", "contrat de garantie"
 * Prestataire (2) -> "Prestation", "Prestations", "contrat de prestation"
 * Both (3) / defaut -> "Garantie" (par defaut)
 */

export interface VendorWording {
  /** "Garantie" ou "Prestation" */
  singular: string;
  /** "Garanties" ou "Prestations" */
  plural: string;
  /** "garantie" ou "prestation" (minuscule) */
  singularLower: string;
  /** "garanties" ou "prestations" (minuscule) */
  pluralLower: string;
  /** "la garantie" ou "la prestation" */
  withArticle: string;
  /** "une garantie" ou "une prestation" */
  withIndefinite: string;
  /** "de garantie" ou "de prestation" */
  deType: string;
  /** "des garanties" ou "des prestations" */
  desPlural: string;
  /** "contrat de garantie" ou "contrat de prestation" */
  contrat: string;
}

const GARANTIE_WORDING: VendorWording = {
  singular: 'Garantie',
  plural: 'Garanties',
  singularLower: 'garantie',
  pluralLower: 'garanties',
  withArticle: 'la garantie',
  withIndefinite: 'une garantie',
  deType: 'de garantie',
  desPlural: 'des garanties',
  contrat: 'contrat de garantie',
};

const PRESTATION_WORDING: VendorWording = {
  singular: 'Prestation',
  plural: 'Prestations',
  singularLower: 'prestation',
  pluralLower: 'prestations',
  withArticle: 'la prestation',
  withIndefinite: 'une prestation',
  deType: 'de prestation',
  desPlural: 'des prestations',
  contrat: 'contrat de prestation',
};

const EXTENSION_WORDING: VendorWording = {
  singular: 'Extension',
  plural: 'Extensions',
  singularLower: 'extension',
  pluralLower: 'extensions',
  withArticle: "l'extension",
  withIndefinite: 'une extension',
  deType: "d'extension",
  desPlural: 'des extensions',
  contrat: 'extension de garantie constructeur',
};

// vendorType constants (avoid importing from society.types to keep this pure)
const VENDOR_TYPE_PRESTATAIRE = 2;

/**
 * Retourne le wording adapte au vendorType
 * @param vendorType 1=Garant, 2=Prestataire, 3=Both
 */
export function getVendorWording(vendorType: number | undefined | null): VendorWording {
  if (vendorType === VENDOR_TYPE_PRESTATAIRE) {
    return PRESTATION_WORDING;
  }
  return GARANTIE_WORDING;
}

/**
 * Retourne le wording adapte au warrantyType (pour le wizard de creation de garantie/prestation)
 * @param warrantyType 0=WARRANTY (Garantie), 1=SERVICE (Prestation)
 */
export function getWarrantyTypeWording(warrantyType: number | undefined | null): VendorWording {
  if (warrantyType === 1) {
    return PRESTATION_WORDING;
  }
  if (warrantyType === 2) {
    return EXTENSION_WORDING;
  }
  return GARANTIE_WORDING;
}
